/**
 * @fileoverview ESM mirror of ../buildTargetUrl.js.
 *
 * See the CJS source for full documentation. Drift between the two is
 * caught by `tests/esm/native-import.test.mjs`.
 *
 * @module @puffin-core/cross-app-policy/buildTargetUrl
 */

import { isLocalhostSource } from './hostMatching.js';
import { composeTenantOrigin, assertSafeRelativePath } from './tenantOrigin.js';

const DASHBOARD_RETURN_URL = '/dashboard';

// The origin branches and the relative-path guard live ONCE in ./tenantOrigin.js, shared with
// buildTenantWebUrl (SECURITY-AND-CONNECTORS-001 P2.3a). The `path` mode moved there.

function assertSafeReturnUrl(returnUrl) {
  assertSafeRelativePath(returnUrl, 'buildTargetUrl: returnUrl');
}

function buildPathForMode(mode, args) {
  if (mode === 'sso-mint') {
    const { crossAppToken } = args;
    if (typeof crossAppToken !== 'string' || crossAppToken.length === 0) {
      throw new Error('buildTargetUrl: crossAppToken is required for sso-mint mode');
    }
    return `/?cat=${encodeURIComponent(crossAppToken)}`;
  }
  if (mode === 'login-redirect') {
    const effectiveReturn = args.returnUrl || DASHBOARD_RETURN_URL;
    assertSafeReturnUrl(effectiveReturn);
    return `/login?returnUrl=${encodeURIComponent(effectiveReturn)}`;
  }
  throw new Error(`buildTargetUrl: unsupported mode "${mode}"`);
}

function buildTargetUrl(args) {
  if (!args || typeof args !== 'object') {
    throw new Error('buildTargetUrl: arguments object is required');
  }
  const { mode, target, subdomain, envPrefix, sourceScheme, sourceHostname } = args;

  if (typeof mode !== 'string' || mode.length === 0) {
    throw new Error('buildTargetUrl: mode is required');
  }
  if (!target || typeof target !== 'object') {
    throw new Error('buildTargetUrl: target is required');
  }
  if (typeof subdomain !== 'string' || subdomain.length === 0) {
    throw new Error('buildTargetUrl: subdomain is required');
  }
  if (typeof target.defaultDomain !== 'string' || target.defaultDomain.length === 0) {
    throw new Error('buildTargetUrl: target.defaultDomain is required');
  }

  const path = buildPathForMode(mode, args);

  const origin = composeTenantOrigin({
    target,
    subdomain,
    envPrefix,
    local: isLocalhostSource(sourceScheme, sourceHostname),
    caller: 'buildTargetUrl',
  });
  return `${origin}${path}`;
}

export { buildTargetUrl, DASHBOARD_RETURN_URL, assertSafeReturnUrl };
